<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :multi-line="true"
    :timeout="snackbar.timeout"
  >
    <v-icon
      left
      color="white"
      class="mr-3"
      v-show="snackbar.messageIcon"
    >
    {{ snackbar.messageIcon }}
    </v-icon>
    {{ snackbar.message }}
    <v-btn
      dark
      flat
      @click="!snackbar.button.cb ? toggleSnackbar() : snackbar.button.cb"
      v-show="snackbar.button.show"
    >
      {{ snackbar.button.text }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'custom-snackbar',
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    },
  },
  methods: {
    toggleSnackbar() {
      this.$store.dispatch('toggleSnackbar', { show: false });
    },
  },
};
</script>
